import { Dependencies } from "dev-center-lib";

export const dependencies = new Dependencies();
